// DO NOT EDIT -- generated from fs/services/fieldmeta/fieldmeta.proto

import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export namespace Fieldmeta {

  export const GetArchivedVarsEndpoint = "/grpc/fieldmeta.Fieldmeta/GetArchivedVars";
  /** Returns archived custom properties and events for the org. */
  export function GetArchivedVars(sender: (req: GetArchivedVarsRequest, endpoint: string) => Promise<GetArchivedVarsResponse>, req: GetArchivedVarsRequest): { promise: () => Promise<GetArchivedVarsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetArchivedVarsEndpoint),
      endpoint: GetArchivedVarsEndpoint
    };
  }

  export const GetVarRulesEndpoint = "/grpc/fieldmeta.Fieldmeta/GetVarRules";
  export function GetVarRules(sender: (req: GetVarRulesRequest, endpoint: string) => Promise<GetVarRulesResponse>, req: GetVarRulesRequest): { promise: () => Promise<GetVarRulesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetVarRulesEndpoint),
      endpoint: GetVarRulesEndpoint
    };
  }

  export const UpdateVarsEndpoint = "/grpc/fieldmeta.Fieldmeta/UpdateVars";
  /** Updates the rule set with the provided rules. */
  export function UpdateVars(sender: (req: UpdateVarsRequest, endpoint: string) => Promise<{}>, req: UpdateVarsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateVarsEndpoint),
      endpoint: UpdateVarsEndpoint
    };
  }
}

export namespace FieldmetaPublic {

  export const GetArchivedVarsEndpoint = "/grpc/fieldmeta.FieldmetaPublic/GetArchivedVars";
  /** Returns archived custom properties and events for the org. */
  export function GetArchivedVars(sender: (req: GetArchivedVarsRequest, endpoint: string) => Promise<GetArchivedVarsResponse>, req: GetArchivedVarsRequest): { promise: () => Promise<GetArchivedVarsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetArchivedVarsEndpoint),
      endpoint: GetArchivedVarsEndpoint
    };
  }

  export const UpdateVarsEndpoint = "/grpc/fieldmeta.FieldmetaPublic/UpdateVars";
  /** Updates the rule set with the provided rules. */
  export function UpdateVars(sender: (req: UpdateVarsRequest, endpoint: string) => Promise<{}>, req: UpdateVarsRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateVarsEndpoint),
      endpoint: UpdateVarsEndpoint
    };
  }
}

export interface GetVarRulesRequest {
  orgId: string;
  /** Optional version to fetch. If 0, then the latest version will be returned. */
  version: protobuf.int64;
  /**
   * Number of versions to fetch before the provided version.
   * If 0, only the requested version will be returned.
   */
  limit: number;
}

export interface GetVarRulesResponse {
  rules: VarRuleSet[];
}

export interface GetArchivedVarsRequest {
  orgId: string;
}

export interface GetArchivedVarsResponse {
  /** Properties and events names that should be hidden from the UI. */
  vars: string[];
}

export interface UpdateVarsRequest {
  orgId: string;
  updates: UpdateVarsRequest.VarUpdate[];
}

export namespace UpdateVarsRequest {
  /**
   * The type, pattern, and optional parent_pattern form a unique key.
   * Existing entries will be updated with the new state.
   * If the state is VAR_STATE_INVALID, the rule will be removed from the set.
   */
  export interface VarUpdate {
    type: VarRule.VarType;
    pattern: string;
    parentPattern: string;
    state: VarRule.VarState;
    applyBefore: protobuf.timestamp | null;
  }
}

export interface VarRule {
  /** The type of var (e.g. user property) */
  type: VarRule.VarType;
  /**
   * The name or pattern for the rule.
   * This value should not contain the scope prefix (i.e. `user_`, `page_`, `evt_`).
   * For explicit names, this value must start with a letter an can be alphanumeric only (including underscores).
   * Dots can also be used to indicate groups (e.g. `object.subfield`).
   * TODO(cam): add pattern support and document
   */
  pattern: string;
  /**
   * Parent currently applies to:
   * - custom event names when the type is `VAR_TYPE_EVENT_PROPERTY`
   * - page def id (numeric as string) when the type is `VAR_TYPE_PAGE_PROPERTY`
   * - element id when the type is `VAR_TYPE_ELEMENT_PROPERTY`
   * If provided, the rule applies only to the parent.
   * If empty, this rule applies to all parents.
   * TODO(cam): add pattern support and document
   */
  parentPattern: string;
  /** State of the var rule */
  state: VarRule.VarState;
  /**
   * If set and non zero, indicates a time at which this rule should only apply before (when applicable).
   * Mostly, this applies to blocking vars.
   */
  applyBefore: protobuf.timestamp | null;
  /** More granular audit information than the overall rule set. */
  lastUpdated: protobuf.timestamp | null;
  lastUpdatedBy: string;
}

export namespace VarRule {
  export enum VarType {
    VAR_TYPE_INVALID = 0,
    VAR_TYPE_USER_PROPERTY = 1,
    VAR_TYPE_EVENT_PROPERTY = 2,
    VAR_TYPE_EVENT_NAME = 3,
    VAR_TYPE_PAGE_PROPERTY = 4,
    VAR_TYPE_ELEMENT_PROPERTY = 5
  }

  /** Each var state implies the state before it */
  export enum VarState {
    VAR_STATE_INVALID = 0,
    VAR_STATE_ARCHIVED = 1,
    VAR_STATE_BLOCKED = 2
  }
}

export interface VarRuleSet {
  rules: VarRule[];
  metadata: protoauditstore.AuditMetadata | null;
}
